import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import Root from './Root';
import Home from './components/Home';
import Signup from './components/account/Signup';
import Login from './components/login/Login';
import ResendActivation from './components/account/ResendActivation';
import ActivateAccount from './components/account/ActivateAccount';
import ResetPassword from './components/account/ResetPassword';
import SuperAdminDashboard from './components/dashboard/SuperAdmin/Dashboard';
import AdminDashboard from './components/dashboard/Admin/Dashboard';
import ResetPasswordConfirm from './components/account/ResetPasswordConfirm';

import requireAuth from './utils/RequireAuth';
import InstructorDashboard from './components/instructor/Home2';
import StudentDashboard from './components/student/Home';
import VideoPage from './components/student/Video';

if (window.location.origin === 'http://localhost:3000') {
  axios.defaults.baseURL = 'http://127.0.0.1:8000';
} else {
  axios.defaults.baseURL = window.location.origin;
}

export default function App() {
  return (
    <div>
      <Root>
        <ToastContainer hideProgressBar={true} newestOnTop={true} />
        <Switch>
          <Route path="/signup" component={Signup} />
          <Route path="/login" component={Login} />
          <Route path="/super-admin" component={SuperAdminDashboard} />
          <Route path="/instructor" component={InstructorDashboard} />
          <Route path="/student" component={StudentDashboard} />
          <Route path="/admin" component={AdminDashboard} />
          <Route path="/video" component={VideoPage} />
          <Route exact path="/" component={Home} />
          <Route path="/resend_activation" component={ResendActivation} />
          <Route path="/activate/:token" component={ActivateAccount} />
          <Route path="/send_reset_password/" component={ResetPassword} />
          <Route
            path="/confirm_reset_password/:token"
            component={ResetPasswordConfirm}
          />
          {/* <Route
            path="/reset_password/:uid/:token"
            component={ResetPasswordConfirm}
          /> */}
        </Switch>
      </Root>
    </div>
  );
}
